export default {
  applies_to_articles: 'Dotyczy następujących produktów',
};
